module.exports = __webpack_public_path__ + "static/media/finger_authen_blue.e8faa1c8.svg";